import styled from 'styled-components'

export const Container = styled.div`
  .image {
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding-bottom: 60%;
    background: ${props => props.theme.palette.general.greyLight} no-repeat 50% 50% / cover;
    transition: box-shadow 300ms ease;
  }

  .content {
    width: 82%;
    margin: 0 auto;
    padding: 0 20px;
    text-align: center;
    box-sizing: border-box;
    background: ${props => props.theme.palette.general.light};
    transition: box-shadow 300ms ease;
  }

  .title {
    ${props => props.theme.css.heading1}
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    color: ${props => props.theme.palette.general.strong};
    font-size: 22px;
    margin: 10px 0;
    transition: color 300ms ease;
  }

  a {
    display: block;
    user-select: none;
    text-decoration: none;
  }
`
